import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SHA256 } from 'crypto-js';
import { JSEncrypt } from 'jsencrypt';
import { AlertService } from '../_alert';
import { ApiService } from '../api.service';
import { DataService } from "../data.service";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  @ViewChild('ngOtpInput', { static: false }) ngOtpInput: any;
  cardForm: UntypedFormGroup;
  mobileForm: UntypedFormGroup;
  editForm: UntypedFormGroup;
  voucherForm: UntypedFormGroup;
  public cardTypeList = [
    { value: 'Virtual Card', display: "I have Virtual Card" },
    { value: 'Physical Card', display: "I have Physical Card" },
    { value: 'Voucher Code', display: "I have Voucher Code" }
  ];
  public mobileSecDisp = false;
  public cardError = false;
  public otpSecDisp = false;
  isSaving = false;
  isResend = false;
  isOtpSaving = false;
  isVoucherSaving = false;
  otpToken: any;
  counter: any;
  interval: any;
  showOtpComponent = true;
  infoModalOpen = false;
  enableCaptcha = false;
  captchSrc: any;
  maxAttempt: any = '';
  config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      width: '35px',
      height: '35px',
      fontSize: '20px'
    }
  };
  public redeemVoucherSecDisp: boolean = false;
  titleText: string = 'Gift Cards!';
  persistObject: any;
  voucherDetails: any;
  preLoginToken: any;

  constructor(
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private dataService: DataService,
    private apiService: ApiService,
    public alertService: AlertService
  ) { }

  initializeForm() {
    this.cardForm = this.formBuilder.group({
      cardType: ['', Validators.required],
    });
    this.mobileForm = this.formBuilder.group({
      mobile: [''],
      cardLastSixDigits: [''],
      kitNo: [''],
      expiryDate: [''],
      pinNo: [''],
      captcha: []
    });
    this.editForm = this.formBuilder.group({
      otp: ['', Validators.required],
      captcha: []
    });
    this.voucherForm = this.formBuilder.group({
      voucherCode: [null, [Validators.required, Validators.pattern('^([A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4})$')]],
      beneficiaryName: [null, [Validators.required, Validators.minLength(1), Validators.maxLength(50), Validators.pattern('^(?!\\.)(?!.*\\.$)(?!.*\\.\\.)(?!\\s)(?!.*\\s$)(?!.*\\s\\s)(?!.*\\s\\.)[a-zA-Z0-9\\s.\'()]+$')]],
      tnc: [false, [Validators.requiredTrue]],
    });
  }

  ngOnInit() {
    this.initializeForm();
    let pathName = window.location.pathname;
    if (pathName === '/login') {
      this.dataService.setVoucherDetails(null);
    }
    if (pathName === '/login/virtual-card') {
      this.getPreLoginToken();
      this.cardForm.get('cardType').setValue('Virtual Card');
      this.next();
    } else if (pathName === '/login/physical-card') {
      this.getPreLoginToken();
      this.cardForm.get('cardType').setValue('Physical Card');
      this.next();
    }
    else if (pathName === '/login/voucher-code') {
      this.getPreLoginToken();
      this.titleText = 'Gift Vouchers!';
      this.cardForm.get('cardType').setValue('Voucher Code');
      this.persistObject = this.dataService.getVoucherDetails();
      if (this.persistObject && this.persistObject.voucherDetails) {
        this.persistObject.voucherDetails.voucherCode ? this.voucherForm.get('voucherCode').setValue(this.persistObject.voucherDetails.voucherCode) : this.voucherForm.get('voucherCode').setValue(null);
        this.persistObject.voucherDetails.beneficiaryName ? this.voucherForm.get('beneficiaryName').setValue(this.persistObject.voucherDetails.beneficiaryName) : this.voucherForm.get('beneficiaryName').setValue(null);
        this.persistObject.voucherDetails.tnc ? this.voucherForm.get('tnc').setValue(this.persistObject.voucherDetails.tnc) : this.voucherForm.get('tnc').setValue(null);
      }
      if (this.persistObject && this.persistObject.voucherDetails) {
        this.displayVoucherPage();
      } else {
        this.next();
      }
    }
  }

  getPreLoginToken() {
    const apiData = {
      "apiType": "get",
      "apiExt": "generate-login-token",
    };
    this.apiService.customPostApiCall({}, apiData).then((res: any) => {
      this.preLoginToken = res.token;
    })
  }

  ngAfterViewInit(): void {
    if (this.apiService.voucherSuccessFlag) {
      this.alertService.success('Your voucher code has been redeemed successfully. You can view the gift card details by login using your mobile number below.', { autoClose: true });
      this.apiService.setVoucherSuccessFlag(false);
    }
  }

  next() {
    if (this.cardForm.value.cardType != '') {
      this.mobileSecDisp = true;
      this.cardError = false;
      this.dataService.setCardType(this.cardForm.value.cardType);
      this.updateValidator();
    }
    else {
      this.cardError = true;
    }
    console.log(this.cardForm.value.cardType);
  }

  displayVoucherPage() {
    this.redeemVoucherSecDisp = true;
    this.dataService.setCardType('Voucher Code');
    this.updateValidator();
  }

  selectCardType() {
    if (this.cardForm.value.cardType != '') {
      if (this.cardForm.value.cardType === 'Physical Card') this.router.navigate(['/login/physical-card'])
      else if (this.cardForm.value.cardType === 'Voucher Code') { this.router.navigate(['/login/voucher-code']) }
      else this.router.navigate(['/login/virtual-card'])
    }
  }

  updateValidator() {
    if (this.cardForm.value.cardType == 'Physical Card') {
      this.mobileForm.get('mobile').clearValidators();
      this.mobileForm.get('cardLastSixDigits').setValidators([Validators.required, Validators.minLength(6), Validators.maxLength(6), Validators.pattern('^[0-9]+$')]);
      this.mobileForm.get('kitNo').setValidators([Validators.required, Validators.pattern('^[0-9]+$')]);
      this.mobileForm.get('expiryDate').setValidators([Validators.required, Validators.minLength(5), Validators.maxLength(5), Validators.pattern('^(1[0-2]|0[1-9])/[0-9]{2}$')]);
      this.mobileForm.get('pinNo').setValidators([Validators.required, Validators.minLength(4), Validators.maxLength(4), Validators.pattern('^[0-9]+$')]);
    } else {
      this.mobileForm.get('mobile').setValidators([Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern('^[0-9]+$')]);
      this.mobileForm.get('cardLastSixDigits').clearValidators();
      this.mobileForm.get('kitNo').clearValidators();
      this.mobileForm.get('expiryDate').clearValidators();
      this.mobileForm.get('pinNo').clearValidators();
    }
    this.mobileForm.get('mobile').updateValueAndValidity();
    this.mobileForm.get('cardLastSixDigits').updateValueAndValidity();
    this.mobileForm.get('kitNo').updateValueAndValidity();
    this.mobileForm.get('expiryDate').updateValueAndValidity();
    this.mobileForm.get('pinNo').updateValueAndValidity();
  }

  submit() {
    if (this.mobileForm.invalid || !this.preLoginToken) {
      if (this.mobileForm.invalid) {
        this.alertService.error('Form is invalid', { autoClose: true })
      }
      if (!this.preLoginToken) {
        this.alertService.error('Token is missing.', { autoClose: true })
      }
      return;
    } else {
      this.maxAttempt = '';
      this.isSaving = true;
      const reqObj: any = {};
      reqObj.token = this.preLoginToken;

      if (this.cardForm.value.cardType != 'Physical Card') {

        reqObj.mobileNo = this.mobileForm.value.mobile;
        reqObj.checksum = this.generateChecksum({
          mobileNo: reqObj.mobileNo,
          token: reqObj.token
        });

      } else {
        var pin = this.mobileForm.value.pinNo;
        var kitNo = this.mobileForm.value.kitNo
        var pinData = "0" + pin.length + pin.padEnd(14, 'F');
        var kitData = kitNo.padStart(16, '0');
        var bPin = this.hexToBytes(pinData);
        var bKit = this.hexToBytes(kitData);

        var pinBlockByte = new Array(bKit.length);

        for (var i = 0; i < bKit.length; i++) {
          pinBlockByte[i] = bPin[i] ^ bKit[i];
        }

        var pinBlock = this.bytesToHex(pinBlockByte).toUpperCase();
        reqObj.cardNoLastsix = this.mobileForm.value.cardLastSixDigits;
        reqObj.kitNo = this.mobileForm.value.kitNo;
        reqObj.expiryDate = this.mobileForm.value.expiryDate;
        reqObj.pin = pinBlock;
        if (this.enableCaptcha) reqObj.captcha = this.mobileForm.value.captcha;
        reqObj.checksum = this.generateChecksum({
          cardNoLastsix: reqObj.cardNoLastsix,
          kitNo: reqObj.kitNo,
          expiryDate: reqObj.expiryDate,
          pin: reqObj.pin,
          token: reqObj.token
        });

      }

      const apiData = { "apiType": "post", "apiExt": "" };

      if (this.cardForm.value.cardType == 'Virtual Card') apiData.apiExt = "gc-user-get-otp";
      else if (this.cardForm.value.cardType == 'Voucher Code') apiData.apiExt = 'voucher/get-otp';
      else if (this.cardForm.value.cardType == 'Physical Card') apiData.apiExt = 'gc-user-validate-physical-card';

      this.apiService.customPostApiCall(reqObj, apiData).then((res: any) => {
        if (res) {
          if (res.enableCaptcha) {
            this.loadCaptcha(false);
          }
          if (this.cardForm.value.cardType == 'Physical Card') this.loginToHome(res);
          else this.mobileNumberSaveSuccess(res);
        } else this.isSaving = false;
      },
        (err) => {
          this.isSaving = false;
          if (err.status === 400 && err.error.errorKey === "invalidToken") {
            this.mobileForm.reset();
            this.getPreLoginToken();
          }
          this.maxAttempt = (err && err.error && err.error.message && err.error.message.includes("left before your account is locked")) ? err.error.message : '';
          if (err.error.enableCaptcha) {
            this.loadCaptcha(err);
          }
        });
    }
  }

  hexToBytes(hex) {
    for (var bytes = [], c = 0; c < hex.length; c += 2)
      bytes.push(parseInt(hex.substr(c, 2), 16));
    return bytes;
  }

  // Convert a byte array to a hex string
  bytesToHex(bytes) {
    for (var hex = [], i = 0; i < bytes.length; i++) {
      var current = bytes[i] < 0 ? bytes[i] + 256 : bytes[i];
      hex.push((current >>> 4).toString(16));
      hex.push((current & 0xF).toString(16));
    }
    return hex.join("");
  }

  mobileNumberSaveSuccess(res: any) {
    this.otpToken = res.otpToken;
    if (res.resendOtpTime) this.counter = res.resendOtpTime;
    this.isSaving = false;
    this.mobileSecDisp = false;
    this.otpSecDisp = true;
    this.enableOtpAutoFocus();
    this.startCountDown();
  }
  startCountDown() {
    this.counter = this.counter || 60;
    this.isSaving = false;
    this.interval = setInterval(() => {
      if (this.counter > 0) this.counter = this.counter - 1;
      else clearInterval(this.interval);
    }, 1000);
  }

  submitOtp() {
    if (this.editForm.invalid) {
      this.alertService.error('Form is invalid', { autoClose: true })
      return;
    } else {
      this.maxAttempt = '';
      this.isOtpSaving = true;
      const reqObj: any = {
        "otpToken": this.otpToken,
        "otp": this.editForm.get('otp').value
      };
      if (this.cardForm.value.cardType != 'Physical Card') {
        if (this.enableCaptcha) {
          reqObj.captcha = this.editForm.value.captcha;
        }
        reqObj.checksum = this.generateOTPChecksum(reqObj.otpToken, reqObj.otp) || null;
      }

      const apiData = {
        "apiType": "post",
        "apiExt": this.cardForm.value.cardType == 'Voucher Code' ? 'voucher/validate-otp' : 'gc-user-validate-otp',
      };

      this.apiService.customPostApiCall(reqObj, apiData).then((res: any) => {
        if (res) {
          if (this.cardForm.value.cardType != 'Voucher Code') {
            this.loginToHome(res)
          } else {
            this.otpSecDisp = false;
            this.isOtpSaving = false;
            this.redeemVoucherSecDisp = true;
          }
        } else this.isOtpSaving = false;
      },
        (err) => {
          this.isOtpSaving = false;
          const otpAttempt = (err && err.error && err.error.title && err.error.title.includes("OTP failed attempts exceeded")) ? err.error.title : '';
          if (otpAttempt) {
            this.maxAttempt = '';
            this.reloadscreen();
            return;
          }
          this.maxAttempt = (err && err.error && err.error.message && err.error.message.includes("left before your account is locked")) ? err.error.message : '';
          if (err.error.enableCaptcha) {
            this.loadCaptcha(err);
          }
          if (err.status === 401) {
            this.initializeForm();
            this.previousState();
          }
        });
    }
  }

  loginToHome(res) {
    let updateReqObj = {
      "loggedIn": true,
      "token": res.id_token,
      "userDetail": {
        "cardType": this.cardForm.value.cardType,
        "mobileNo": this.mobileForm.value.mobile,
      },
    };
    this.apiService.updateUserDetail(updateReqObj);
    localStorage.setItem('userObj', JSON.stringify(updateReqObj));
    this.getAllGifrCards(updateReqObj);
    this.isSaving = false;
  }

  getAllGifrCards(updateReqObj) {
    const apiData = {
      "apiType": "get",
      'apiExt': `giftCards?page=${0}&size=${10}&sort=id,asc`
    };
    this.apiService.customGetApiCall({}, apiData).then((res: any) => {
      updateReqObj.cardCount = res.data.length;
      this.apiService.updateUserDetail(updateReqObj);
      localStorage.setItem('userObj', JSON.stringify(updateReqObj));
      if (res && res.data && res.data.length === 1) {
        this.router.navigate(['/card-detail', res.data[0].id]);
      } else {
        this.router.navigate(['/home']);
      }
    },
      (error) => { });
  }
  onOtpChange(otp: any) {
    if (otp && otp.toString().length === 6) this.editForm.get('otp').setValue(otp);
    else this.editForm.get('otp').setValue('');
  }

  resendOtp() {
    this.isResend = true;
    const reqObj = {
      "otpToken": this.otpToken,
    };
    const apiData = {
      "apiType": "post",
      "apiExt": this.cardForm.value.cardType == 'Voucher Code' ? 'voucher/resend-otp' : 'gc-user-resend-otp',
    };
    this.apiService.customPostApiCall(reqObj, apiData).then((res: any) => {
      if (res) {
        this.mobileNumberSaveSuccess(res);
      }
      this.isResend = false;
    },
      (err) => {
        this.isResend = false;
        const otpAttempt = (err && err.error && err.error.title && err.error.title.includes("OTP failed attempts exceeded")) ? err.error.title : '';
        if (otpAttempt) {
          this.maxAttempt = '';
          this.reloadscreen();
          return;
        }
        if (err.status === 401) {
          this.initializeForm();
          this.previousState();
        }
      });
  }

  enableOtpAutoFocus() {
    if (this.ngOtpInput) {
      this.ngOtpInput.setValue(null);
    }
    this.editForm.get('otp').setValue(null);
    setTimeout(() => {
      this.config.disableAutoFocus = false;
      this.showOtpComponent = true;
    });
  }
  previousState() {
    this.mobileSecDisp = false;
    this.otpSecDisp = false
  }
  infoModalClose() {
    this.infoModalOpen = !this.infoModalOpen
  }

  onYpexpDateChange(event) {
    if (event.length === 2 && !event.includes("/")) {
      this.mobileForm.get('expiryDate').setValue(event + '/');
    }
  }

  loadCaptcha(err: any) {
    const userType = 'GCPORTAL'
    this.captchSrc = '';
    if (err && err.error && err.error.limitExpire) { this.reloadscreen(); return }
    setTimeout(() => {
      const timeStmp = new Date().getTime();
      this.editForm.get('captcha').setValue('');
      this.mobileForm.get('captcha').setValue('');
      // const SERVER_API_URL = this.apiService.baseUrl;
      const SERVER_API_URL = this.apiService.getCaptchaURL();
      if (this.cardForm.value.cardType != 'Physical Card') {
        const mobileNo = this.mobileForm.get('mobile').value;
        this.captchSrc = `${SERVER_API_URL}captcha?userName=${mobileNo}&timeStamp=${timeStmp}&userType=${userType}`
      } else {
        const kitNo = this.mobileForm.get('kitNo').value;
        this.captchSrc = `${SERVER_API_URL}captcha?userName=${kitNo}&timeStamp=${timeStmp}&userType=${userType}`
      }
      this.enableCaptcha = true;
      this.editForm.get('captcha').setValidators([Validators.required]);
      this.editForm.get('captcha').updateValueAndValidity();
      this.mobileForm.get('captcha').setValidators([Validators.required]);
      this.mobileForm.get('captcha').updateValueAndValidity();
    });
  }

  reloadscreen() {
    this.mobileSecDisp = false;
    this.cardError = false;
    this.otpSecDisp = false;
    this.enableCaptcha = false;
    this.showOtpComponent = true;

    this.initializeForm();
  }

  redeemVoucher() {
    if (this.voucherForm.invalid) {
      this.alertService.error('Form is invalid', { autoClose: true })
      return;
    } else {
      this.isVoucherSaving = true;
      const reqObj = {
        "voucherCode": this.voucherForm.get('voucherCode').value,
        "beneficiaryName": this.voucherForm.get('beneficiaryName').value
      };
      const apiData = {
        "apiType": "post",
        "apiExt": 'voucher/redeem-voucher',
      };
      this.apiService.customPostApiCall(reqObj, apiData).then((res: any) => {
        if (res && res.status === "SUCCESS") {
          this.apiService.setVoucherSuccessFlag(true);
          this.router.navigate(['/login/virtual-card']);
        } else {
          this.isVoucherSaving = false;
          this.alertService.error(res.responseMessage, { autoClose: true })
        }
      },
        (err: HttpErrorResponse) => {
          this.alertService.error('Something went wrong.', { autoClose: true })
          this.isVoucherSaving = false;
          console.log(err);
        }
      );
    }
  }

  openInfo(flag: any) {
    if (flag == 'VOU') {
      this.alertService.success('Voucher code should be 12-digit alphanumeric value. Special characters are not allowed.', { autoClose: true, title: 'Voucher Code' })
    } else if (flag == 'BEN') {
      this.alertService.success('Beneficiary Name can contain alphanumeric, spaces or . \' ( ) only.', { autoClose: true, title: 'Beneficiary Name' })
    }
  }

  onInput(input: any) {
    if (input.value.length > 50) {
      input.value = input.value.substr(0, 50);
      this.voucherForm.get('beneficiaryName').setErrors(null);
    }
  }

  setTitleText() {
    if (this.cardForm.value.cardType !== 'Voucher Code') this.titleText = 'Gift Cards!';
    else this.titleText = 'Gift Vouchers!';
  }

  goToTermsPage() {
    this.dataService.setVoucherDetails(this.createTncObj());
    this.router.navigate(['/terms']);
  }

  createTncObj() {
    const reqObj: any = {};
    reqObj.voucherCode = this.voucherForm.value.voucherCode
    reqObj.beneficiaryName = this.voucherForm.value.beneficiaryName
    reqObj.tnc = this.voucherForm.value.tnc
    return reqObj;
  }

  generateChecksum(checksumData: any) {
    if (this.cardForm.value.cardType != 'Physical Card') {
      var data = checksumData.mobileNo + "~" + checksumData.token;
    } else {
      var data = checksumData.cardNoLastsix + "~" + checksumData.kitNo + "~" + checksumData.expiryDate + "~" + checksumData.pin + "~" + checksumData.token;
    }
    const checksum = SHA256(data).toString();
    return checksum;
  }

  generateOTPChecksum(otpToken: any, otp: any) {
    const data = otpToken + "~" + otp;
    const checksum = SHA256(data).toString();
    return checksum;
  }

}
